import { unwrapResult } from '@reduxjs/toolkit'
import { Col, message, Modal, notification, } from 'antd'
import moment from 'moment'
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import SimpleAgGrid from '../../../../compnents/simpleTable/SimpleAgGrid'
import { ThemeContext } from '../../../../theme/ThemeContext'
import { selectEdition } from '../../../../app/applicationSlice'
import { getPageColumnListAsync, getSubmitPageColumnListAsync } from '../../../transactionQuery/transactionQuerySlice'
import { getDentalLedgerDeleteAsync, getDoctorAuditEntriesList, getDoctorAuditEntriesListExportAsync } from './dentureLedgerSlice'
import { DoctorAuditEntrieAGColumns } from './column'
import { getSortColumnList } from '../../../../models/common'
import { Query } from './Query'
import { DateTimeFormatSimpleOnlyOne } from '../../../../models/datetime'
import { getDateRange, DateRangeType } from '../../../../compnents/form/DateSelect'
import styles from './dentureLedgerPage.module.css'
import { AddOrEditFalseToothModal } from './addOrEditFalseToothModal'
import { ExclamationCircleFilled } from '@ant-design/icons'

interface DentureLedgerPageProps {
  onLeftCount?: (obj: any) => void
  flag?: any
  SYCKHRSJHData?: boolean
}

const DentureLedgerPage = (
  { onLeftCount, SYCKHRSJHData }: DentureLedgerPageProps,
): ReactElement => {
  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const [visible, setVisible] = useState(false)

  const [id, setId] = useState<any>()

  // 所有的列表
  const listData: any = [
    {
      headerName: '序号',
      width: 80,
      minWidth: 80,
      field: 'index',
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '患者姓名',
      field: 'patientName',
      width: 120,
      minWidth: 120,
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '性别',
      field: 'sex',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '年龄',
      field: 'ageYear',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '手机号',
      field: 'phoneNumber',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '义齿品种',
      field: 'variety',
      minWidth: 180,
      visible: true,
    },
    {
      headerName: '牙位',
      field: 'toothPosition',
      minWidth: 170,
      visible: true,
    },
    {
      headerName: '生产单位',
      field: 'productionUnit',
      minWidth: 180,
      visible: true,
    },
    {
      headerName: '注册证号',
      field: 'registrationCertificateNo',
      minWidth: 180,
      visible: true,
    },
    {
      headerName: '定制单编号',
      field: 'customOrderNo',
      minWidth: 160,
      visible: true,
    },
    {
      headerName: '定制日期',
      field: 'customDate',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '医生',
      field: 'doctorName',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '操作',
      field: 'action',
      width: 150,
      minWidth: 150,
      pinned: 'right',
      lockPosition: "right",
      suppressMovable: true,
      visible: true,
    },
  ]?.map((v,index)=>{
    return {
      ...v,
      index: index + 1,
    }
  })

  const allData = listData

  // 默认要展示的列的值
  const selectColumns = allData?.filter((v: any) => v.visible)?.map((item: any) => item.field) || []

  const [allColumnList, setAllColumnList] = useState<any[]>([]) //筛选列所有的数据

  const [filterSelectList, setFilterSelectList] = useState<any[]>([]) //筛选列所有的数据

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname + '_yichitaizhang') || '{}'
  )

  const [timeHead, timeTail] = getDateRange(DateRangeType.Today)

  const [params, setParams] = useState<any>({
    current: storageParams?.current ? Number(storageParams?.current) : 1,
    size: 10,
  })

  const [page, setPage] = useState<any>()

  const [pageLoading, setPageLoading] = useState(false)

  const [exportLoading, setExportLoading] = useState(false)

  useEffect(() => {
    setAllColumnList(allData)
  }, [])

  const submitPageList = (data: any) => {
    const params = {
      pageName: 'dentureLedgerPage',
      configJson: JSON.stringify(data),
    }
    dispatch(getSubmitPageColumnListAsync({
      ...params,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        getPageColumnList(v?.id)
      })
  }

  const getPageColumnList = (id?: any) => {
    dispatch(getPageColumnListAsync({
      id: id ? id : undefined,
      pageName: 'dentureLedgerPage',
    }))
      .then(unwrapResult)
      .then((v: any) => {
        const data: any = v?.configJson ? JSON.parse(v?.configJson) : []
        const filterList = data?.filter((n: any) => n?.visible)
        const columns = filterList?.map((n: any) => n?.field)
        const resetData = data?.map(((v: any) => {
          const sameFileds = allData?.find((item: any) => item?.field == v?.field)
          return {
            ...v,
            minWidth: sameFileds?.minWidth || v?.minWidth,
            width: sameFileds?.width || v?.width,
            headerName: sameFileds?.headerName || v?.headerName,
          }
        }))
        // 所有的数据
        setAllColumnList(data?.length ? resetData : allData)
        // 筛选后存在后端的数据

        // 选中的值
        setFilterSelectList(columns?.length ? columns : selectColumns)
      })
      .catch(() => {
        setAllColumnList(allData)
        setFilterSelectList(selectColumns)
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  useEffect(() => {
    if (params?.startDate ){
      setPageLoading(true)
      getPage()
      getPageColumnList()
    }
  }, [params])

  const getPage = () => {
    dispatch(getDoctorAuditEntriesList({ ...params }))
      .then(unwrapResult)
      .then((v: any) => {
        setPage({
          items: v?.records,
          size: v?.size,
          total: v?.total,
          current: v?.current,
        })
      })
      .catch(() => {
        setPageLoading(false)
      })
  }

  useEffect(() => {
    params.current &&
      sessionStorage.setItem(
        location.pathname + '_yichitaizhang',
        JSON.stringify({ ...params })
      )
  }, [params])


  const outCluedExport = () => {
    setExportLoading(true)
    dispatch(
      getDoctorAuditEntriesListExportAsync({
        ...params,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '义齿台账.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        notification.success({
          message: '导出失败',
          duration: 3,
        })
      })
      .finally(() => {
        setExportLoading(false)
      })
  }

  // 表格双击跳转
  const tableDoubleFn = (record: any) => {
    return
  }

  return (
    <>
      <Col
        style={{ backgroundColor: theme.pn }}
        className={styles.container}
      >
        <Query
          loading={pageLoading}
          exportLoading={exportLoading}
          onValueChange={(v: any) => {
            const paramData = {
              ...params,
              ...v,
              startDate: v?.timeHead && moment(v?.timeHead).isValid()
                ? moment(v?.timeHead).format(DateTimeFormatSimpleOnlyOne)
                : moment(timeHead).format(DateTimeFormatSimpleOnlyOne),
              endDate: v?.timeTail && moment(v?.timeTail).isValid()
                ? moment(v?.timeTail).format(DateTimeFormatSimpleOnlyOne)
                : moment(timeTail).format(DateTimeFormatSimpleOnlyOne),
              timeHead: undefined,
              timeTail: undefined,
              current: v?.current
                ? v?.current
                : storageParams?.current
                  ? storageParams?.current
                  : 1,
            }
            setParams({
              ...paramData,
            })
            onLeftCount && onLeftCount(paramData)
          }}
          add={() => {
            setId('')
            setVisible(true)
          }}
          exportExcel={() => outCluedExport()}
          filterColumn={allColumnList} //筛选列
          filterSelectList={filterSelectList}
          // 筛选列变化时的数据
          submitPageList={(v: any) => {
            setPageLoading(true)
            submitPageList(v)
            setAllColumnList(v)
          }}
        />
        <div
          style={{
            width: '100%',
            height: '100%',
          }}
        >
          <SimpleAgGrid
            rowHeight={71}
            page={page}
            column={(DoctorAuditEntrieAGColumns(
              page?.size * (page?.current - 1),
              (action, t,) => {
                switch (action) {
                  case 'edit':
                    setId(t?.id)
                    setVisible(true)
                    break
                  case 'delete':
                    Modal.confirm({
                      centered: true,
                      title: '确认操作',
                      content: (
                        <div>
                          <ExclamationCircleFilled
                            style={{
                              color: '#FFAE55',
                              fontSize: 18,
                            }}
                          />
                          &nbsp;是否确认删除？
                        </div>
                      ),
                      okText: '确认',
                      cancelText: '取消',
                      icon: null,
                      onOk: () => {
                        dispatch(getDentalLedgerDeleteAsync({
                          id: t?.id,
                        }))
                          .then(unwrapResult)
                          .then(() => {
                            notification.success({
                              message: '操作成功',
                              duration: 3,
                            })
                            getPage()
                            getPageColumnList()
                            onLeftCount && onLeftCount(params)
                          })
                      },
                    })
                    break
                }
              },
              allColumnList,
              SYCKHRSJHData
            ))?.filter((item: any) => filterSelectList?.includes(item.field))}
            isLoading={pageLoading}
            pagination={true}
            pageKey={'dentureLedgerPage'}
            rowSelection="multiple"
            onRowDoubleClick={(event: any) => tableDoubleFn(event.data)}
            suppressRowClickSelection={true}
            onChangePage={(current, size) => {
              setParams({
                ...params,
                current,
                size,
              })
            }}
            onColumnResized={(v) => {
              return
            }}
            onColumnMoved={(v) => {
              // setPageLoading(true)
              const sortList = getSortColumnList(allColumnList, v);
              submitPageList(sortList)
              setAllColumnList(sortList)
            }}
          />
        </div>
      </Col>
      <AddOrEditFalseToothModal
        SYCKHRSJHData={SYCKHRSJHData}
        id={id}
        visible={visible}
        onOk={() => {
          setVisible(false)
          getPage()
          getPageColumnList()
          setId('')
          onLeftCount && onLeftCount(params)
        }}
        onCancel={() => {
          setId('')
          setVisible(false)
        }}
      ></AddOrEditFalseToothModal>
    </>

  )
}

export const DentureLedgerPages = forwardRef(DentureLedgerPage)